import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { setChatDialog } from './redux';
import ChatBadge from './ChatBadge';
import { withChatBoundary } from './ChatErrorBoundary';
import { chatIndicator, chatUnreadCount } from './chatState';

// „Чат извън задача" в горната лента — точката е за общия чат на графика (сива — няма чат или не е поет, червена с броя
// непрочетени или зелена — chatIndicator).
const GeneralChatButton = ({ style, disabled }) => {
  const dispatch = useDispatch();
  const enabled = useSelector(state => state.chat.enabled);
  const indicator = useSelector(state => chatIndicator(state.chat, x => !x.scheduleTaskId));
  const count = useSelector(state => chatUnreadCount(state.chat, x => !x.scheduleTaskId));

  if (!enabled) return null;

  return (
    <ChatBadge indicator={indicator} count={count}>
      <Button
        style={style}
        variant="contained"
        onClick={() => dispatch(setChatDialog({ open: true, scheduleTaskId: null, title: '' }))}
        disabled={disabled}
      >
        Чат извън задача
      </Button>
    </ChatBadge>
  );
};

export default withChatBoundary(GeneralChatButton);
